import * as React from "react";

const Discovery: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 20"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <g fill="none" fillRule="evenodd">
                <rect width="32" height="20" fill="#4D4D4D" rx="2" />
                <path
                    fill="#FFF"
                    d="M3.51 7.233v2.618h.22c.53 0 .865-.096 1.123-.315.283-.238.454-.617.454-.997s-.17-.748-.454-.985c-.271-.231-.593-.32-1.122-.32h-.22zm23.143-.047v1.199h.24c.523 0 .8-.214.8-.612 0-.385-.277-.587-.788-.587h-.252zm-.819-.623h1.216c.945 0 1.487.427 1.487 1.168 0 .606-.34 1.004-.957 1.122l1.323 1.668h-1.008L26.76 8.93h-.107v1.59h-.819V6.563zm-2.869 0h2.326v.67h-1.506v.879h1.45v.67h-1.45v1.069h1.506v.67h-2.326V6.563zM6.53 10.52h.82V6.563h-.82v3.958zM2.69 6.563h1.204c1.33 0 2.257.814 2.257 1.982 0 .582-.284 1.145-.764 1.519-.403.315-.863.457-1.5.457H2.691V6.563zm15.862-.006h.896l1.121 2.658 1.136-2.658h.889l-1.816 4.06h-.442l-1.784-4.06zm-9.37-.07c.461 0 .883.15 1.235.44l-.429.529c-.213-.226-.415-.32-.66-.32-.354 0-.612.188-.612.438 0 .214.145.327.637.498.933.321 1.209.606 1.209 1.235 0 .766-.598 1.3-1.45 1.3-.624 0-1.077-.232-1.455-.754l.53-.48a.977.977 0 00.894.527c.366 0 .637-.237.637-.558a.469.469 0 00-.246-.41c-.082-.047-.246-.118-.567-.225-.77-.26-1.034-.54-1.034-1.085 0-.648.567-1.134 1.311-1.134zm3.877-.024c.353 0 .649.071 1.009.243v.908c-.341-.314-.637-.445-1.029-.445-.769 0-1.373.6-1.373 1.36 0 .8.586 1.364 1.412 1.364.371 0 .662-.124.99-.433v.909c-.373.165-.675.23-1.029.23-1.248 0-2.218-.902-2.218-2.065 0-1.151.996-2.071 2.238-2.071z"
                />
                <path
                    fill="#F47216"
                    d="M32 12.007V18a2 2 0 01-2 2H10.237c4.593-.937 8.712-2.075 12.358-3.413 3.645-1.34 6.78-2.866 9.405-4.58zM16.572 6.435c1.235 0 2.236.942 2.236 2.105v.001c0 1.163-1 2.105-2.236 2.105-1.235 0-2.236-.942-2.236-2.105V8.54c0-1.163 1.001-2.105 2.236-2.105z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Discovery);
